import { styled } from '@mui/system';
import { Box, Button } from '@mui/material';

export const AccountContainer = styled(Box)({
  backgroundColor: '#2E2E2E',
  padding: '20px',
  borderRadius: '12px',
  width: '300px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  zIndex: 2,
});

export const AccountButton = styled(Button)({
  backgroundColor: '#3E3E3E',
  color: 'white',
  textTransform: 'none',
  padding: '10px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  '&:hover': {
    backgroundColor: '#4A4A4A',
  },
});

export const SignOutButton = styled(Button)({
  backgroundColor: '#5A1F1F',
  color: '#FF6B6B',
  textTransform: 'none',
  padding: '10px',
  width: '100%',
  '&:hover': {
    backgroundColor: '#7A2F2F',
  },
});
